import React from 'react';
import gettext from '@eb/gettext';

import { ofuscateEmail } from '../utils/security';

import MagicLinkAccountSectionModalButton from '../connectedComponents/MagicLinkAccountSectionModalButton/index';

import './MagicLinkAccountSection.scss';

const MagicLinkAccountSection = ({ email, onLinkAccount }) => (
    <>
        <div className="eds-text-hm eds-text-bl eds-text-color--ui-800 eds-l-pad-bot-8">
            {gettext('Link your accounts and login with just one click:')}
        </div>

        <div className="magic-link-button-container eds-text-bs eds-l-pad-bot-2">
            <MagicLinkAccountSectionModalButton
                modalButtonText={gettext('Send a magic link')}
                textWithOfuscatedEmail={gettext(
                    `We sent you a link to your email, ${ofuscateEmail({
                        email,
                    })}`,
                )}
                onLinkAccount={onLinkAccount}
            />
        </div>

        <div className="eds-text-bs eds-text-color--ui-600">
            {gettext(`An email will be set to ${ofuscateEmail({ email })}`)}
        </div>
    </>
);

MagicLinkAccountSection.defaultProps = {
    email: '',
    onLinkAccount: () => {},
};

export default MagicLinkAccountSection;
